"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

var link_component_1 = require("../link/link.component");

var search_dropdown_component_1 = __importDefault(require("../search-dropdown/search-dropdown.component"));

var HeaderMainRow = function (props) {
  var _a, _b;

  var mainRowRef = (0, react_1.useRef)(null);
  (0, react_1.useEffect)(function () {
    var _a, _b, _c, _d;
    /** Set the top offset of the fixed mobile menu */


    if (((_a = mainRowRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== props.mobileMenuOffset) {
      props.setMobileMenuOffset((_d = (_c = (_b = mainRowRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) === null || _c === void 0 ? void 0 : _c.bottom) !== null && _d !== void 0 ? _d : 113);
    }
    /** Prevent scroll on the page */


    document.body.classList.toggle('rwc-body-lock', props.isMobileMenuOpen);
  }, [props.isMobileMenuOpen]);
  var bem = (0, hook_use_bem_classes_1.default)('rwc-header-main-row');
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: bem(),
    ref: mainRowRef
  }, {
    children: (0, jsx_runtime_1.jsxs)("div", __assign({
      className: bem('container')
    }, {
      children: [(0, jsx_runtime_1.jsxs)("button", __assign({
        onClick: function () {
          return props.setIsMobileMenuOpen(!props.isMobileMenuOpen);
        },
        className: bem('menu-button')
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: props.isMobileMenuOpen ? 'fas-xmark' : 'fas-bars',
          size: "16"
        }), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "span"
        }, {
          children: props.mobileMenuText
        }))]
      })), (0, jsx_runtime_1.jsxs)("a", __assign({
        className: bem('logo'),
        href: (_a = props.logoLink) === null || _a === void 0 ? void 0 : _a.linkUrl,
        target: (_b = props.logoLink) === null || _b === void 0 ? void 0 : _b.linkTarget
      }, {
        children: [(0, jsx_runtime_1.jsx)("div", __assign({
          className: bem('logo-image')
        }, {
          children: props.logo
        })), (0, jsx_runtime_1.jsx)("div", {
          className: bem('logo-bar')
        }), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "span",
          className: bem('logo-text')
        }, {
          children: props.logoText
        }))]
      })), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('buttons')
      }, {
        children: [props.primaryLink && (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: (0, classnames_1.default)(bem('button'), bem('button', 'primary'), 'rwc-header--mobile-hide')
        }, props.primaryLink)), props.secondaryLink && (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: (0, classnames_1.default)(bem('button'), bem('button', 'secondary'), 'rwc-header--mobile-hide')
        }, props.secondaryLink)), props.searchOptionLinks && (0, jsx_runtime_1.jsx)(search_dropdown_component_1.default, {
          searchOptionLinks: props.searchOptionLinks
        })]
      }))]
    }))
  }));
};

exports.default = HeaderMainRow;